import React from "react";

export default class TreeNode extends React.Component {}
TreeNode.propTypes = {
  value: React.PropTypes.string
};



// WEBPACK FOOTER //
// ./_rc-tree-select-1.8.8/src/TreeNode.jsx